import React from "react";
import { History } from "lucide-react";

interface Order {
  service_type: string;
  delivered_at: string | null;
}

interface CareHistoryCardProps {
  lastFlowers: Order | undefined;
  lastCleaning: Order | undefined;
}

const formatDate = (isoString: string | null | undefined) => {
  if (!isoString) return null;
  return new Date(isoString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const CareHistoryCard: React.FC<CareHistoryCardProps> = ({ lastFlowers, lastCleaning }) => {
  return (
    <div className="bg-card rounded-xl shadow-sm border overflow-hidden transition-all duration-300 hover:shadow-md">
      <div className="border-b bg-muted/30 px-6 py-4 flex items-center">
        <History className="h-5 w-5 text-primary mr-2" />
        <h3 className="font-medium text-foreground">Care History</h3>
      </div>
      <div className="p-6 space-y-3">
        {lastFlowers && (
          <div className="flex justify-between items-center">
            <span className="text-foreground">Last flowers</span>
            <span className="text-muted-foreground">{formatDate(lastFlowers.delivered_at)}</span>
          </div>
        )}
        {lastCleaning && (
          <div className="flex justify-between items-center">
            <span className="text-foreground">Last cleaning</span>
            <span className="text-muted-foreground">{formatDate(lastCleaning.delivered_at)}</span>
          </div>
        )}
      </div>
    </div>
  );
};
